module.exports = __webpack_public_path__ + "static/img/03.27e3c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/03.jpg
// module id = j10R
// module chunks = 0